export default "__VITE_ASSET__69416a06__"